module.exports = "/packs/images/homepage/facilities/woman_doing_yoga~3773a49ae2da4dbd94532e38e1635816.png";